import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SharedDataService } from '../shared-data/shared-data.service';
import {RestAPIService} from "../shared-service/restAPI.service";
import {CustomerInfo} from "../../customer-info";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() details: any;
  dashboardUrl: any;
  releaseNotesUrl: string;
  private ngpPortalUrl: string = "https://ngp.qa.cyber.entreda.com";
  private portalName: string = "staging-ag-qa";
  customerInfo: CustomerInfo;
  constructor(
    private restAPIService: RestAPIService,
    public router: Router,
    public sharedDataService: SharedDataService
  ) {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd && window.innerWidth <= 992) {
        /*setTimeout(this.toggleSidebar, 3000);
                                document.querySelector('body').classList.remove('push-right');    */
        this.toggleSidebar();
      }
    });
  }

  ngOnInit() {
    this.restAPIService.getCustomerInfo().then(customerInfo => {
      this.customerInfo = customerInfo;
      this.portalName = this.customerInfo.portal.split(".")[0];
      if(this.portalName.includes("dev")){
        this.ngpPortalUrl = "https://ngp.dev.cyber.entreda.com";
      }else if(this.portalName.includes("qa")){
        this.ngpPortalUrl = "https://ngp.qa.cyber.entreda.com";
      } else if(this.portalName.includes("staging")){
        this.ngpPortalUrl = "https://ngpstaging.entreda.com";
      }else if(this.portalName.includes("prod")){
        this.ngpPortalUrl = "https://prodngpserver.entreda.com";
      } else{
        console.error("Not able to get environment from portalName: ", this.portalName);
      }
    }).catch(error => {
      console.error(error.message);
    });
    this.releaseNotesUrl = this.ngpPortalUrl.concat("/#/release-notes?portalName=").concat(this.portalName);
  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    // setTimeout( function() {dom.classList.toggle('push-right')}, 3000);
    dom.classList.toggle('push-right');
    setTimeout(function () {
      dom.classList.remove('push-right');
    }, 3000);
  }

  redirectToPortalDashboard() {
    window.location.href =
      'https://' + this.sharedDataService.getCustomerInfo().portal;
  }
}
